module.exports = __webpack_public_path__ + "static/media/item-pool.04743877.png";